// Environment
export const kProduction = import.meta.env.MODE === 'production'
export const kStaging = import.meta.env.MODE === 'staging'

// Default logo path
export const kDefaultLogoPath = '/images/paxton-web-600.png'
export const kOrganizationLogoFileName = 'organization-logo.png'

// Favicon paths
export const kDefaultFaviconPath = '/images/paxton-favicon.png'

// Global Toast
export { kToastDurationDefaultMs as kGlobalToastDurationMs, kToastDurationShortMs, kToastDurationMediumMs, kToastDurationLongMs } from './constants-toast'

export enum GlobalToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  /** Expected outcome worth stating, where nothing failed. */
  INFO = 'info',
}

// File Processing Time (estimated)
export const kFileProcessingTimeMs = 70000

// Tooltip hover delay, so a tooltip only opens once the cursor settles on its trigger
export const kTooltipHoverDelayMs = 1000

// Max combined documents length
export const kMaxCombinedDocumentsLength = 350000

// Basic HTML sanitization allowed tags
// See default options: https://www.npmjs.com/package/sanitize-html
// REMOVED:
// - 'a' (links)
export const kSanitizationAllowedTags = [
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hgroup',
  'main',
  'nav',
  'section',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'figcaption',
  'figure',
  'hr',
  'li',
  'main',
  'ol',
  'p',
  'pre',
  'ul',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'data',
  'dfn',
  'em',
  'i',
  'kbd',
  'mark',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'u',
  'var',
  'wbr',
  'caption',
  'col',
  'colgroup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
]

// GCS MD Allowed Tags
export const kGcsMdAllowedTags = [...kSanitizationAllowedTags]

// Docx2Html Allowed Tags
export const kDocx2HtmlAllowedTags = [...kSanitizationAllowedTags, 'title']

// LRR Source
// See default options: https://www.npmjs.com/package/sanitize-html
// REMOVED:
// - 'a' (links)
export const kLrrSourceSanitizationAllowedTags = [
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hgroup',
  'main',
  'nav',
  'section',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'figcaption',
  'figure',
  'hr',
  'li',
  'main',
  'ol',
  'p',
  'pre',
  'ul',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'data',
  'dfn',
  'em',
  'i',
  'kbd',
  'mark',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'u',
  'var',
  'wbr',
  'caption',
  'col',
  'colgroup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
]

// Document Editing Markdown -> HTML Allowed HTML Tags
// See default options: https://www.npmjs.com/package/sanitize-html
// REMOVED:
// - 'a' (links)
export const kDocumentEditingAllowedTags = [
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hgroup',
  'main',
  'nav',
  'section',
  'button',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'figcaption',
  'figure',
  'hr',
  'li',
  'main',
  'ol',
  'p',
  'pre',
  'ul',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'data',
  'dfn',
  'em',
  'i',
  'kbd',
  'mark',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'u',
  'var',
  'wbr',
  'caption',
  'col',
  'colgroup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
  'font',
]
